// Routes owned by the Marketing module. Merged into the app-wide `paths` object
// by src/app/paths.ts; see src/modules/README.md.
export const marketingPaths = {
    customerMkt: '/contacts',
    customerNewlMkt: '/contacts/new',
    hrContact: '/contacts/humanresources',
} as const
